import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import theme from "../../../theme";

export const PriceTestIconFilled = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      sx={{ width: props.width ?? "58px", height: props.height ?? "58px" }}
    >
      <svg viewBox={"0 0 58 58"} fill="none" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29 54.999c14.359 0 26-11.416 26-25.5S43.359 4 29 4 3 15.416 3 29.5 14.64 55 29 55v-.001Zm2.363-39.409c0-1.28-1.058-2.318-2.363-2.318s-2.363 1.038-2.363 2.318v1.357c-3.336.756-5.909 3.6-5.909 7.13s2.588 6.447 6.062 7.162l3.29.678c1.506.31 2.467 1.527 2.467 2.813 0 1.504-1.323 2.884-3.161 2.884H29c-1.716 0-3.069-1.099-3.44-2.455-.338-1.236-1.634-1.97-2.895-1.639-1.26.332-2.009 1.603-1.67 2.84.737 2.7 2.91 4.788 5.642 5.563v1.487c0 1.28 1.058 2.318 2.363 2.318s2.363-1.038 2.363-2.318v-1.4c3.35-.829 5.909-3.714 5.909-7.279s-2.655-6.615-6.222-7.35l-3.29-.678c-1.412-.291-2.306-1.43-2.306-2.624 0-1.398 1.232-2.69 2.956-2.69H29c1.716 0 3.069 1.098 3.44 2.454.338 1.237 1.634 1.97 2.895 1.639 1.261-.332 2.009-1.603 1.671-2.84-.738-2.7-2.91-4.787-5.642-5.563V15.59Z"
          fill={props.fill ?? theme.palette.primary.main}
        />
      </svg>
    </SvgIcon>
  );
};
